<template>
  <div>
    <generic-container
      :title="$t('season list')"
      icon="school"
      :show_plus="true"
      :configurable="true"
      v-bind:configure_modal="configure_modal"
      v-on:add="add"
      :header_buttons="header_buttons"
    >
      <table
        class="ui blue very compact celled striped selectable table"
        ref="table"
        style="width: 100%"
      >
        <thead>
          <tr>
            <th>{{ $t("name") }}</th>
            <th>{{ $t("start date") }}</th>
            <th>{{ $t("end date") }}</th>
            <th>{{ $t("is default") }}</th>
            <th>{{ $t("options") }}</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(season, sidx) in course_assignations" :key="sidx">
            <td>{{ season.name }}</td>
            <td>
              {{
                season.start_date
                  | formatDate(enterprise_setup.simple_date_format)
              }}
            </td>
            <td>
              {{
                season.end_date
                  | formatDate(enterprise_setup.simple_date_format)
              }}
            </td>
            <td>
              <i class="green check icon" v-show="season.is_default"></i>
            </td>
            <td>
              <div
                class="ui mini basic icon button"
                :data-tooltip="$t('edit')"
                @click.stop="edit(season, sidx)"
              >
                <i class="orange edit icon"></i>
              </div>
              <div
                class="ui mini basic icon button"
                :data-tooltip="$t('section distribution')"
                @click.stop="show_distribution(season, sidx)"
              >
                <i class="olive users icon"></i>
              </div>
              <div
                class="ui mini basic icon button"
                :data-tooltip="$t('section revision')"
                @click.stop="show_revision(season)"
              >
                <i class="blue eye icon"></i>
              </div>
              <div
                class="ui mini basic icon button"
                :data-tooltip="$t('statistics')"
                @click.stop="statistics(season)"
              >
                <i class="purple chart area icon"></i>
              </div>
              <div
                class="ui mini basic icon button"
                :data-tooltip="$t('delete')"
                @click.stop="remove(season, sidx)"
              >
                <i class="red trash icon"></i>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
      <!-- <div class="ui three link cards">
        <div
          v-for="(assignation, index) in course_assignations"
          :key="index"
          @click="show_distribution(assignation)"
          v-bind:class="{
            green: assignation.setup.is_active,
            red: !assignation.setup.is_active,
          }"
          class="card"
        >
          <div class="content">
            <div class="ui dividing header">{{ assignation.name }}</div>
            <div class="description">
              <h4 class="ui dividing head">{{ $t("general") }}</h4>
              <div class="ui bulleted list">
                <div class="item">
                  {{ $t("status") }}:
                  {{
                    assignation.setup.is_active ? $t("active") : $t("inactive")
                  }}
                </div>
                <div
                  class="item"
                  v-for="(gral, idx) in assignation.setup.general"
                  :key="idx"
                >
                  {{ gral.name }}: {{ gral.value }}
                </div>
              </div>
              <h4 class="ui dividing head">{{ $t("courses") }}</h4>
              <div class="ui bulleted list">
                <div
                  class="item"
                  v-for="(crs, idx) in assignation.setup.courses"
                  v-show="idx < 10"
                  :key="idx"
                >
                  {{ crs.name }}
                </div>
              </div>
            </div>
          </div>
          <div class="ui bottom attached basic buttons">
            <div class="ui button" @click.stop="edit(assignation, index)">
              <i class="edit icon"></i>
              {{ $t("edit") }}
            </div>
            <div class="ui button" @click.stop="show_revision(assignation)">
              <i class="blue eye icon"></i>
              {{ $t("revision") }}
            </div>
            <div class="ui button" @click.stop="remove(assignation, index)">
              <i class="red trash icon"></i>
              {{ $t("delete") }}
            </div>
          </div>
        </div>
      </div> -->
    </generic-container>
    <template v-for="(mdl, index) in assignation_modals">
      <component
        :is="mdl"
        :key="index"
        v-on:destroy="destroy"
        v-on:succedded="succedded"
        :assignation_in="selected_assignation"
      ></component>
    </template>
    <statistics-modal ref="statistics_modal" />
  </div>
</template>

<script>
import filters from "@/filters";
import GenericContainer from "@/components/GenericContainer";
import ConfigureModal from "./configuration_modal/Index.vue";
import AssignationModal from "./assignation_modal/Index";
import StatisticsModal from "./statistics_modal/Index";
import {
  local_api,
  error_toast,
  // init_ajax_data_datables,
  enterprise_setup,
} from "@/utils";

// @ is an alias to /src
export default {
  name: "CourseAssignationIndex",
  components: {
    "generic-container": GenericContainer,
    StatisticsModal,
  },
  filters: filters,
  data() {
    return {
      course_assignations: [],
      configure_modal: ConfigureModal,
      assignation_modals: [],
      selected_assignation: undefined,
      header_buttons: [
        {
          icon: "refresh",
          tooltip: this.$t("refresh"),
          click: this.refresh,
        },
      ],
    };
  },
  computed: {
    enterprise_setup() {
      return enterprise_setup(this);
    },
  },
  methods: {
    add() {
      this.assignation_modals.push(AssignationModal);
    },
    succedded(/* assignation */) {
      // let trgtIdx = this.courses.findIndex((n) => n.uuid == assignation.uuid);
      // if (trgtIdx == -1) {
      //   this.course_assignations.push(assignation);
      // } else {
      //   this.course_assignations.splice(trgtIdx, 1, assignation);
      // }
      this.refresh();
    },
    destroy() {
      this.assignation_modals = [];
      this.selected_assignation = {};
      this.refresh();
    },
    show_distribution(assignation) {
      this.$router.push({
        name: "CourseAssignationDistribution",
        query: { i: assignation.uuid },
      });
    },
    refresh() {
      let vm = this;
      local_api(vm, "post", "/course/assignation/do-get-season-list", {})
        .then((seasons) => {
          vm.course_assignations = seasons;
        })
        .catch((err) => {
          error_toast(err);
        });

      // let columns = [
      //   {
      //     data: function(row) {
      //       return row.name;
      //     },
      //   },
      //   {
      //     data: function(row) {
      //       return filters.formatDate(
      //         row.start_date || "",
      //         vm.enterprise_setup.simple_date_format,
      //       );
      //     },
      //   },
      //   {
      //     data: function(row) {
      //       return filters.formatDate(
      //         row.end_date || "",
      //         vm.enterprise_setup.simple_date_format,
      //       );
      //     },
      //   },
      //   {
      //     data: function(row) {
      //       if (row.is_default) {
      //         return `<i class="green check icon"></i>`;
      //       } else return "";
      //     },
      //   },
      //   {
      //     data: function(/* row */) {
      //       return `<div class="ui mini icon button">
      //                 <i class="orange edit icon"></i>
      //               </div>
      //               <div class="ui mini icon button">
      //                 <i class="blue eye icon"></i>
      //               </div>
      //               <div class="ui mini red icon button">
      //                 <i class="trash icon"></i>
      //               </div>`;
      //     },
      //   },
      // ];

      // let onSelect = (data) => {
      //   vm.show_distribution(data);
      // };

      // init_ajax_data_datables(
      //   vm,
      //   vm.$refs.table,
      //   window.jQuery.fn.api.settings.api["course assignation seasons url"],
      //   columns,
      //   onSelect,
      // );
    },
    remove(assignation, index) {
      let vm = this;
      this.$alertify.confirm(
        this.$t("are you sure to remove assignation season?"),
        function () {
          local_api(vm, "post", "/course/assignation/do-delete-season", {
            u: assignation.uuid,
          })
            .then(() => {
              vm.course_assignations.splice(index, 1);
            })
            .catch((err) => {
              error_toast(err);
            });
        },
      );
    },
    edit(assignation) {
      this.selected_assignation = assignation;
      this.assignation_modals.push(AssignationModal);
    },
    show_revision(assignation) {
      this.$router.push({
        name: "CourseAssignationRevision",
        query: { i: assignation.uuid },
      });
    },
    statistics(season) {
      let vm = this;
      vm.$refs.statistics_modal.show_modal(season);
    },
  },
  created() {},
  mounted() {
    this.refresh();
  },
  watch: {},
};
</script>
